export default __webpack_public_path__ + "ddc3ab520b8d90d001a7896678354afd.ttf";